import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import Routes from './routes';
import { ToastContainer } from 'react-toastify';
import PesquisaMarcaIndecx from '~/components/Portal/PesquisaMarcaIndecx';

import './utils/i18n';
import 'react-toastify/dist/ReactToastify.css';
import './components/styles/Global.css';
import './components/styles/Slides.css';

function App() {
  useEffect(() => {
    const script = document.createElement('script');

    if (
      process.env.REACT_APP_ENV === 'build-prod' ||
      process.env.REACT_APP_ENV === 'prod'
    ) {
      script.type = 'text/javascript';
      script.crossOrigin = 'anonymous';
      script.src =
        'https://js-cdn.dynatrace.com/jstag/1624d0f62e6/bf82227shx/ee65062b9c0b78e8_complete.js';
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      if (document?.body) {
        document?.body?.removeChild(script);
      }
    };
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="background">
          <PesquisaMarcaIndecx />
          <ToastContainer
            className="toast-container-push"
            position="top-right"
            autoClose={10000}
            hideProgressBar={false}
            rtl={false}
            newestOnTop
            closeOnClick
            pauseOnVisibilityChange
            draggable
            pauseOnHover
            enableMultiContainer
          />
          <Routes />
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
